import {BaseService} from "../domain-services/base-service";
import {singleton} from "../decorators/singleton";

@singleton
export class BaseUtils extends BaseService {
  static injectables = [...BaseService.injectables];
}
